import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromUI from '../reducers/ui.reducer';

// Projects state
export const getUIState = createSelector(fromFeature.getProductsState, (state: fromFeature.DashboardState) => state.ui);

export const getRoutesState = createSelector(getUIState, fromUI.getState);
